import { BaseModel } from "@blue-chip/core";
import PurchaseOrder from "./PurchaseOrder";
import User from "./User";

export default class PurchaseOrderChangeRecords extends BaseModel {
  static get tableName() {
    return "purchase_order_change_records";
  }

  static get belongsTo() {
    return [PurchaseOrder, User];
  }
}
